import { action, computed, makeObservable, observable } from 'mobx';

export default class ModalDelegate {
  private _isVisible = false;

  get isVisible(): boolean {
    return this._isVisible;
  }

  open(): void {
    this._isVisible = true;
  }

  close(): void {
    this._isVisible = false;
  }

  constructor(initialState = false) {
    this._isVisible = initialState;
    makeObservable<ModalDelegate, '_isVisible'>(this, {
      _isVisible: observable,
      isVisible: computed,
      open: action.bound,
      close: action.bound,
    });
  }
}
